export function setLocalStorage (scope, data) {
  let storage = getLocalStorage(`airelink:${scope}`)
  storage = Object.assign(storage, data)
  window.localStorage.setItem(`airelink:${scope}`, JSON.stringify(storage))
}

export function getLocalStorage (scope) {
  return JSON.parse(window.localStorage.getItem(`airelink:${scope}`)) || {}
}
